import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { Users, Calendar, Briefcase, Compass, ShoppingBag } from "lucide-react";

const sections = [
  { to: "/comunidade", key: "community", icon: Users, desc: "A Comunidade Geral, as comunidades da tua cidade e os espaços oficiais." },
  { to: "/eventos", key: "events", icon: Calendar, desc: "Festas, cultura, música, workshops e mais." },
  { to: "/marketplace", key: "marketplace", icon: ShoppingBag, desc: "Produtos, serviços e restaurantes de vendedores da comunidade." },
  { to: "/empregos", key: "jobs", icon: Briefcase, desc: "Vagas de emprego para a comunidade." },
];

export default function Explore() {
  const { t } = useLang();
  return (
    <div className="page fade-up">
      <div className="pt-4 pb-4 flex items-center gap-2">
        <Compass className="text-[#c8102e]" size={22} />
        <h1 className="font-display text-2xl font-extrabold">{t("explore")}</h1>
      </div>
      <div className="space-y-3 mb-8">
        {sections.map(({ to, key, icon: I, desc }) => (
          <Link key={to} to={to} data-testid={`explore-${key}`}
                className="flex items-center gap-4 p-4 bg-white rounded-2xl border border-zinc-200 card-hover">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-black to-[#c8102e] flex items-center justify-center text-white shrink-0">
              <I size={22} />
            </div>
            <div className="flex-1">
              <div className="font-display font-bold text-base">{t(key)}</div>
              <div className="text-xs text-zinc-500 leading-relaxed">{desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
